import React from 'react'
import moment from 'moment'
import { Document, Page, StyleSheet, Text, View } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  page: { padding: 24, fontSize: 11, fontFamily: 'Helvetica' },

  header: { marginBottom: 16 },
  title: { fontSize: 16, textAlign: 'center', marginBottom: 6 },
  metaRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  metaText: { fontSize: 9, color: '#444' },

  logItem: {
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#e5e5e5',
  },
  logTopRow: { flexDirection: 'row', justifyContent: 'space-between' },
  logTime: { fontSize: 9, color: '#666' },
  logAuthor: { fontSize: 9, color: '#666' },
  logBody: { marginTop: 4, fontSize: 11 },
})

const TacticalLogsPDF = ({ logs = [], startDate, endDate, printed }) => {
  if (logs.length === 0) {
    return (
      <Document>
        <Page size="A4" style={styles.page}>
          <Text>No logs found for this date range.</Text>
        </Page>
      </Document>
    )
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.header}>
          <Text style={styles.title}>Tactical Logs</Text>

          <View style={styles.metaRow}>
            <Text style={styles.metaText}>
              {startDate && endDate ? `From ${startDate} to ${endDate}` : ''}
            </Text>
            <Text style={styles.metaText}>
              {printed ? `Printed by: ${printed}` : ''}
            </Text>
          </View>
        </View>

        <View>
          {logs.map((x, idx) => {
            // Adjust these field names to match your schema:
            const message =
              typeof x.log === 'string'
                ? x.log
                : x.log?.message || x.log?.text || JSON.stringify(x.log)

            const createdAt = x.createdAt || x.log?.createdAt
            const author = x.author
              ? `${x.author.firstName} ${x.author.lastName}`
              : ''

            return (
              <View key={x._id || idx} style={styles.logItem}>
                <View style={styles.logTopRow}>
                  <Text style={styles.logAuthor}>{author}</Text>
                  <Text style={styles.logTime}>
                    {moment(createdAt).format('Do MMM YYYY HH:mm')}
                  </Text>
                </View>
                <Text style={styles.logBody}>{message}</Text>
              </View>
            )
          })}
        </View>
      </Page>
    </Document>
  )
}

export default TacticalLogsPDF
